import { i18nCdpNamespace } from "@/constants";
import { brandConfiguration } from "@/brands/config";
import { useTranslation } from "@aviv-unified-frontend/runtime/i18n";
export const useI18n = () => {
    const { locale, i18nResources, CP47Locale } = brandConfiguration;
    const { addTranslations, t } = useTranslation(i18nCdpNamespace);
    const translations = i18nResources[locale][i18nCdpNamespace];
    addTranslations({ language: locale, translations });
    return { t, locale, CP47Locale };
};
